module.exports = __webpack_public_path__ + "static/hcdriedmango-b8dfe5a24f28e8520e0e1120b793b775.jpg";